import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    container: {
        position: 'relative',
        width: '100%',
        top: 0,
    },
    streamingBox: {
        width: '100%',
        top: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        height: 'auto',
        [theme.breakpoints.down('lg')]: {
            paddingTop: '5px',
            paddingBottom: '5px',
        },
        [theme.breakpoints.up('lg')]: {
            borderRadius: '10px 10px 0 0',
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    startText: {
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        color: 'white',
        fontSize: '22px',
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginLeft: '44px',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginLeft: '22px',
        },
    },
    linkToStreaming: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    button: {
        marginRight: '20px',
        borderRadius: '50px',
        fontSize: '18px',
        minWidth: '150px',
        borderWidth: 0,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        width: 'auto',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingBottom: '10px',
        paddingTop: '10px',
        textTransform: 'none',
        textDecoration: 'none',
        fontWeight: 400,
        [theme.breakpoints.up('xl')]: {
            height: '55px',
            fontSize: '22px',
        },
    },
}));
